import { buildReducer } from '../../utils/redux/getReduxModuleByFeatureName';
import getConstantsByFeatureName from '../../utils/redux/getConstantsByFeatureName';
import getActionCreators from '../../utils/redux/getActionCreators';
import getActionHandlers from '../../utils/redux/getActionHandlers';
import getSelectorByFeatureName from '../../utils/redux/getSelectorByFeatureName';
import getCRUDSagas from './sagas';
import getCustomSagas from './customSagas';
import { initialState as commonInitialState } from '../../utils/redux/commonActionHandlers';
import Api from '../../utils/Api';
import {fromStore} from "../../utils/localStorageStore";


const constantsPrefix = 'USERS';
const statePropName = 'users';
const formStatePropName = 'users';
const mainPageUrl = '/users';

const initialState = {
  ...commonInitialState,
  filter: fromStore('users.filter', {
    role: null,
    status: null,
    company_manager_name: null,
    favorites: false,
    hot: false,
  }),
  filterExpanded: fromStore('users.filterExpanded', {
    status_id: true,
  }),
  filterType: fromStore('users.filterType', {
    tags: false,
    deadweight: false,
    age: false,
    equasis_vessel_type_id: false,
    external_links: false,
  }),
  
  // SEAFARER PRE-CHECK SECTION
  preCheckDialogOpen: false,
  preCheckLoading: false,
  preCheckError: null,
  preCheckResult: null,
  preCheckData: null,
};

const constants = {
  ...getConstantsByFeatureName(constantsPrefix),
  CHANGE_FILTER_EXPANDED: `@${constantsPrefix}/CHANGE_FILTER_EXPANDED`,
  CHANGE_FILTER_TYPE: `@${constantsPrefix}/CHANGE_FILTER_TYPE`,
  
  // SEAFARER PRE-CHECK CONSTANTS
  SET_PRE_CHECK_DIALOG_OPEN: `@${constantsPrefix}/SET_PRE_CHECK_DIALOG_OPEN`,
  CHECK_SEAFARER_UNIQUENESS_REQUEST: `@${constantsPrefix}/CHECK_SEAFARER_UNIQUENESS_REQUEST`,
  CHECK_SEAFARER_UNIQUENESS_SUCCESS: `@${constantsPrefix}/CHECK_SEAFARER_UNIQUENESS_SUCCESS`,
  CHECK_SEAFARER_UNIQUENESS_ERROR: `@${constantsPrefix}/CHECK_SEAFARER_UNIQUENESS_ERROR`,
  CLEAR_PRE_CHECK_RESULT: `@${constantsPrefix}/CLEAR_PRE_CHECK_RESULT`,
  CLEAR_PRE_CHECK_DATA: `@${constantsPrefix}/CLEAR_PRE_CHECK_DATA`,
};
const actions = {
  ...getActionCreators(constants),
  changeFilterExpanded: (filterExpanded) => ({
    type: constants.CHANGE_FILTER_EXPANDED,
    payload: filterExpanded,
  }),
  changeFilterType: (filterType) => ({
    type: constants.CHANGE_FILTER_TYPE,
    payload: filterType,
  }),
  
  // SEAFARER PRE-CHECK ACTIONS
  setPreCheckDialogOpen: (open) => ({
    type: constants.SET_PRE_CHECK_DIALOG_OPEN,
    payload: open,
  }),
  checkSeafarerUniquenessRequest: (data) => ({
    type: constants.CHECK_SEAFARER_UNIQUENESS_REQUEST,
    payload: data,
  }),
  checkSeafarerUniquenessSuccess: (result) => ({
    type: constants.CHECK_SEAFARER_UNIQUENESS_SUCCESS,
    payload: result,
  }),
  checkSeafarerUniquenessError: (error) => ({
    type: constants.CHECK_SEAFARER_UNIQUENESS_ERROR,
    payload: error,
  }),
  clearPreCheckResult: () => ({
    type: constants.CLEAR_PRE_CHECK_RESULT,
  }),
  clearPreCheckData: () => ({
    type: constants.CLEAR_PRE_CHECK_DATA,
  }),
};
const actionHandlers = getActionHandlers(constants);
const reducer = buildReducer(initialState, {
  ...actionHandlers,
  [constants.CLEAR_FILTER]: (state) => ({
    ...state,
    filter: { },
  }),
  [constants.CHANGE_FILTER_EXPANDED]: (state, action) => ({
    ...state,
    filterExpanded: {
      ...state.filterExpanded,
      [action.payload.name]: action.payload.value,
    },
  }),
  [constants.CHANGE_FILTER_TYPE]: (state, action) => ({
    ...state,
    filterType: {
      ...state.filterType,
      [action.payload.name]: action.payload.value,
    },
  }),
  
  // SEAFARER PRE-CHECK HANDLERS
  [constants.SET_PRE_CHECK_DIALOG_OPEN]: (state, action) => ({
    ...state,
    preCheckDialogOpen: action.payload,
    preCheckError: null,
    preCheckResult: null,
  }),
  [constants.CHECK_SEAFARER_UNIQUENESS_REQUEST]: (state, action) => ({
    ...state,
    preCheckLoading: true,
    preCheckError: null,
    preCheckData: action.payload,
  }),
  [constants.CHECK_SEAFARER_UNIQUENESS_SUCCESS]: (state, action) => ({
    ...state,
    preCheckLoading: false,
    preCheckResult: action.payload,
  }),
  [constants.CHECK_SEAFARER_UNIQUENESS_ERROR]: (state, action) => ({
    ...state,
    preCheckLoading: false,
    preCheckError: action.payload,
  }),
  [constants.CLEAR_PRE_CHECK_RESULT]: (state) => ({
    ...state,
    preCheckLoading: false,
    preCheckError: null,
    preCheckResult: null,
  }),
  [constants.CLEAR_PRE_CHECK_DATA]: (state) => ({
    ...state,
    preCheckDialogOpen: false,
    preCheckLoading: false,
    preCheckError: null,
    preCheckResult: null,
    preCheckData: null,
  }),
}, {
  ...initialState,
  filter: { ...initialState.filter },
  state: {
    isFull: false,
    engineTypeInputValue: '',
    engineTypeInputDebouncedValue: '',
  },
});
const selector = getSelectorByFeatureName(statePropName);


const crudSagas = getCRUDSagas(
  mainPageUrl,
  Api.users,
  actions,
  constants,
  formStatePropName,
  statePropName,
  { itemName: 'User' },
);

const customSagas = getCustomSagas(actions, constants);

const sagas = () => [...crudSagas(), ...customSagas()];

export { constants, actions, reducer, selector, sagas };
